import {Injectable} from '@angular/core';
import {DataCoreService, DlistDto} from '@dabnet-kamu/libs/ui';
import {BehaviorSubject} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ControlConditionModel} from "../../../models/gen-control.model";

@Injectable()
export class TemHesapService {
  public period!: number;
  public isMain!: boolean;
  public onlyMainAccount!: boolean;
  public onlyDetayAccount!: boolean;
  public baseEntity!: string;
  public codeStart!: string | string[];
  public accountCodeLength: number;

  public notContain:boolean =false
  public conditionColName: any;
  public conditionColText: any;
  public controlCondition: ControlConditionModel[];
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsList$ = this._gridControlsList.asObservable();

  constructor(private dataCoreService: DataCoreService, private _httpClient: HttpClient) {
  }


  setParams(period: number, isMain: boolean, codeStart?: string | string[], accountCodeLength?: number,controlCondition?:any,
    notContain?:boolean,baseEntity?:string,onlyMainAccount?:boolean,isReadOnly?:boolean, isBindCheck?:boolean) {
    this.period = period;
    this.isMain = isMain;
    this.codeStart = codeStart
    this.accountCodeLength = accountCodeLength;
    this.controlCondition=controlCondition
    this.notContain=notContain
    this.baseEntity=baseEntity
    this.onlyMainAccount=onlyMainAccount
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }

  getData(code: string,control:any, period: number, isMain: boolean, codeStart?: string | string[], baseEntity?: string, accountCodeLength?: number, isSetData?: boolean) {
     let dataSource: any;
     let tableName = "";
    const filterArr = [];
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select([]);
    } 
    else{
      dataSource = this.dataCoreService.getOData(baseEntity);
    dataSource.select([]);

      
    if (period) filterArr.push(['Donem', '=', period]);
    // codeStart bir dizi ise, her bir değeri için startswith koşulu ekle
    if (codeStart) {
      if (Array.isArray(codeStart)) {
        // Birden fazla startswith koşulunu or ile gruplandır
        const elements = codeStart.map((start) => ['HesapKod', 'startswith', start]);
        // İlk elemandan sonra 'or' ekleyerek hepsini tek bir array olarak ekle
        const withOr = elements.flatMap((element, index) => index < elements.length - 1 ? [element, 'or'] : [element]);
        filterArr.push(withOr)
      } else {
        // Tek bir codeStart değeri varsa
        filterArr.push(['HesapKod', 'startswith', codeStart]);
      }
    }
    if(this.controlCondition){
      this.controlCondition.forEach((item:any) => {
        if(this.notContain){
          filterArr.push(['!',[item.conditionColName, item.conditionColSymbol, item.conditionColText]]);
        } else {
          filterArr.push([item.conditionColName, item.conditionColSymbol, item.conditionColText]);
        }
      });
    }

    //filterArr.push([filterColumn, 'startswith', code])

    if (!isMain) filterArr.push(['DetaySayisi', '=', 0]);
    }
    if (code) filterArr.push(['HesapKod', 'startswith', code]);

    if (filterArr.length > 0) dataSource.filter(filterArr);

    return dataSource;
  }

}
